export const getBajaCaliforniaData = () => ({
  name: "Baja California",
  country: "Mexique",
  description: "Baja California est la principale région viticole du Mexique, représentant environ 70% de la production nationale. Son climat méditerranéen, ses brises marines et ses sols variés en font un terroir unique pour des vins de grande qualité.",
  type: "region",
  mapAreas: [
    { region: "Baja California", x: 20, y: 40, color: "#4B164C", size: 5 }
  ],
  statistics: {
    totalArea: "3,500 ha",
    production: "0.21 million hectolitres",
    appellations: "Aucune (région libre)",
    subregions: "4 vallées principales",
    exportPercentage: "15%"
  },
  characteristics: {
    climate: "Climat méditerranéen avec influence océanique, brumes matinales, étés chauds et secs",
    soil: "Sols granitiques, argileux, sableux, excellente drainage",
    viticulture: "Viticulture moderne, irrigation contrôlée, vendanges manuelles, expérimentation variétale"
  },
  wineStyles: {
    red: "Vins rouges puissants, fruités, souvent assemblages internationaux (Cabernet, Syrah, Tempranillo, Nebbiolo)",
    white: "Vins blancs frais et aromatiques (Chardonnay, Chenin Blanc, Sauvignon Blanc)",
    rose: "Rosés fruités et vifs, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle, production croissante"
  },
  history: "La viticulture à Baja California débute au XVIIIe siècle avec les missions espagnoles. Depuis les années 1980, la région connaît un essor qualitatif, attirant des vignerons innovants et des investissements internationaux.",
  foodPairing: "Cuisine mexicaine moderne, fruits de mer, tacos de poisson, ceviche, grillades, fromages locaux.",
  subregions: {
    "valle-de-guadalupe": {
      name: "Valle de Guadalupe",
      description: "Cœur de la viticulture mexicaine, reconnu pour ses vins rouges complexes et ses assemblages innovants.",
      characteristics: {
        climate: "Méditerranéen, brises marines, nuits fraîches",
        soil: "Sols granitiques et argileux",
        viticulture: "Vignobles modernes, expérimentation variétale"
      },
      grapeVarieties: {
        red: ["Cabernet Sauvignon", "Syrah", "Nebbiolo", "Tempranillo"],
        white: ["Chardonnay", "Sauvignon Blanc", "Chenin Blanc"]
      },
      wineStyles: {
        "rouge": "Assemblages puissants et complexes",
        "blanc": "Vins frais et aromatiques"
      },
      foodPairing: "Tacos de poisson, ceviche, grillades, fromages locaux"
    },
    "valle-de-santo-tomas": {
      name: "Valle de Santo Tomás",
      description: "Vallée historique, deuxième plus ancienne région viticole du Mexique, réputée pour ses rouges élégants.",
      characteristics: {
        climate: "Méditerranéen, influence océanique",
        soil: "Sols argileux et sableux",
        viticulture: "Vignobles traditionnels et modernes"
      },
      grapeVarieties: {
        red: ["Tempranillo", "Merlot", "Cabernet Sauvignon"],
        white: ["Chardonnay", "Viognier"]
      },
      wineStyles: {
        "rouge": "Rouges élégants et équilibrés",
        "blanc": "Blancs aromatiques et frais"
      },
      foodPairing: "Viandes grillées, plats épicés, fromages affinés"
    },
    "valle-de-ojos-negros": {
      name: "Valle de Ojos Negros",
      description: "Vallée d'altitude, réputée pour ses vins rouges structurés et ses blancs minéraux.",
      characteristics: {
        climate: "Plus frais, altitude élevée",
        soil: "Sols granitiques et calcaires",
        viticulture: "Vignobles en altitude, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Cabernet Sauvignon", "Syrah"],
        white: ["Chardonnay", "Sauvignon Blanc"]
      },
      wineStyles: {
        "rouge": "Rouges structurés et puissants",
        "blanc": "Blancs minéraux et tendus"
      },
      foodPairing: "Plats de viande, fromages, cuisine mexicaine épicée"
    },
    "valle-de-san-vicente": {
      name: "Valle de San Vicente",
      description: "Vallée côtière, connue pour ses rouges fruités et ses blancs frais.",
      characteristics: {
        climate: "Méditerranéen, forte influence océanique",
        soil: "Sols sableux et argileux",
        viticulture: "Vignobles proches de la mer, brises constantes"
      },
      grapeVarieties: {
        red: ["Tempranillo", "Merlot"],
        white: ["Chardonnay", "Sauvignon Blanc"]
      },
      wineStyles: {
        "rouge": "Rouges fruités et souples",
        "blanc": "Blancs frais et aromatiques"
      },
      foodPairing: "Fruits de mer, poissons grillés, plats légers"
    }
  }
}); 